import React from "react";



import Blog from "../components/Blog";

const AllCourses = () => {
  return (
    <div>
      
      <Blog/>
      
    </div>
  );
};

export default AllCourses;
